export const generateDate = (): Date => new Date()
export const generateId = (): string => Math.random().toString()
